export const locale = {
    lang: 'ds',
    data: {
        'TITLE': {
            'Project': 'Projekt',
        },
        'FIELDS': {
            "Role": "Rolle",
           
        },
        'MESSAGES': {
            'Saved': 'Gemt succesfuldt.',
        },
        'BUTTONS': {
            'Save': 'Gem',
        }
    }
};
